// 1.Dependency
import {
    createRouter,
    createWebHistory,
    // createWebHashHistory,
} from "vue-router";

import { i18n } from "@/locale";
const { t } = i18n.global;

// import User from '@2kog/pkg-common/utils/user'
import Settings from "@/settings.js";
import { updateMetaTag } from "@/utils/dom";
import User from "@2kog/pkg-common/utils/user";

// 2.Routes
const modules = import.meta.glob(
    [
        "./**/*.js", // 匹配 router 下所有 js
        "!./index.js", // 排除 index.js
    ],
    { eager: true }
);
const routesFromModules = Object.values(modules).flatMap((mod) => {
    const v = mod.default;
    return Array.isArray(v) ? v : v ? [v] : [];
});
export const constantRoutes = [
    {
        name: "index",
        path: "/",
        redirect: "/contract/index",
    },
    ...routesFromModules,
];

// 3.Build An Instance
const router = createRouter({
    // history: createWebHashHistory(import.meta.env.BASE_URL),
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: constantRoutes,
});

// 5. Global Guard
router.beforeEach(async (to, from, next) => {
    const { title, keywords, description } = to.meta || {};
    // 标题
    document.title = title ? `${t(title)}${t("pages.page_title_suffix")}` : Settings.Title;

    // 关键字
    if (keywords) {
        updateMetaTag("keywords", t(keywords));
    }

    // 描述
    if (description) {
        updateMetaTag("description", t(description));
    }

    // 从路由获取token
    const _token = to.query._sso;
    if (_token && !from.query._sso) {
        try {
            // URLSearchParams.get() 会将 + 转为空格,需要转回来
            // 然后再进行 base64 解码和 JSON 解析
            const base64Token = _token.replace(/\s/g, "+");
            const tokenData = JSON.parse(atob(base64Token));

            // 这里可以将 tokenData 存储到 localStorage 或 sessionStorage
            // 例如: localStorage.setItem('token', tokenData.token);
            // 或者存储到 Vuex/Pinia store 中
            await User.update(tokenData);

            // 移除 URL 中的 token 参数,使用 vue-router 的方式重定向
            // eslint-disable-next-line no-unused-vars
            const { _sso, ...queryWithoutToken } = to.query;
            next({
                path: to.path,
                query: queryWithoutToken,
                replace: true,
            });
            return;
        } catch (error) {
            console.error("Token 解析失败:", error);
        }
    }

    // document.documentElement.classList.add("p-" + (to.name || "page"));
    next();
});

export default router;
